import z from "zod";

export const BranchesSchema = z
  .array(
    z.object({
      branchId: z.string().optional(),
      branchName: z.string().optional(),
      active: z.boolean().optional(),
    })
  )
  .optional();

export type BranchesFormType = z.infer<typeof BranchesSchema>;
